<template>
<!-- 抽奖 -->
  <div class="box">
    <div class="box_b">
      <van-search
        v-model="mobile"
        show-action
        label=""
        placeholder="请输入用户手机号"
        @clear="onClickButton"
      >
        <template #action>
          <div @click="onClickButton">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="fg"></div>
    <div class="box_a" v-for="(item, index) in datalist" :key="index">
      <div class="box_a_a">
        <div class="box_a_a1">用户账号：</div>
        <div class="box_a_a2 box_a_a3">{{ item.mobile }}</div>
      </div>
      <div class="box_a_a">
        <div class="box_a_a1">奖品：</div>
        <div class="box_a_a2">{{ item.award_alias }}</div>
      </div>
      <div class="box_a_a">
        <div class="box_a_a1">中奖时间：</div>
        <div class="box_a_a2">{{ item.update_time }}</div>
      </div>
      <div class="box_a_a">
        <div class="box_a_a1">所在科目：</div>
        <div class="box_a_a2">{{ item.appName }}</div>
      </div>
      <div class="box_a_a">
        <div class="box_a_a1">班次：</div>
        <div class="box_a_a2">{{ item.vn_name }}</div>
      </div>
      <div class="box_a_a">
        <div class="box_a_a1">班次有效期：</div>
        <div class="box_a_a2">{{ item.vn_end_date }} <span v-if="item.vn_end_date.length>0">到期</span></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPrize } from "../api/api.js";
export default {
  data() {
    return {
      mobile: "",
      datalist: [],
    };
  },
  created() {
    this.onClickButton();
    // // var data ={
    // //     mobile:this.mobile
    // // }
    // getPrize().then((res) => {});
  },
  mounted() {},
  methods: {
    onClickButton() {
      var data = {
        mobile: this.mobile,
      };
      getPrize(data).then((res) => {
        this.datalist = res.data.data;
      });
    },
  },
};
</script>
<style  scoped>
.box_a {
  margin: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 30px;
  padding: 10px;
}
.fg {
  margin-top: 120px;
}
.box_a_a {
  display: flex;
}
.box_a_a1 {
  width: 30%;
  text-align: right;
}
.box_a_a2 {
  width: 70%;
}
.box {
  height: 100vh;
  overflow-y: scroll;
}
.box_a_a2 {
  padding-top: 4px;
}
.box_b {
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
}
</style>